import AssociatesReportFilters from './FiltersPage';

export default AssociatesReportFilters;
